export default __webpack_public_path__ + "05a801baf268ba979fd88a0b4032b4c4.ttf";